import AIG_image from "../assets/Seguros/AIG_SEGUROS_logo.webp";
import ALLIANZ_SEGUROS_image from "../assets/Seguros/ALLIANZ_SEGUROS_logo.webp";
import ANA_SEGUROS_image from "../assets/Seguros/ANA_SEGUROS_logo.webp";
// import ASISMED_SEGUROS_image from "../assets/Seguros/ASISMED_SEGUROS_logo.webp";
import ATLAS_SEGUROS_image from "../assets/Seguros/ATLAS_SEGUROS_logo.webp";
import AXA_SEGUROS_image from "../assets/Seguros/AXA_SEGUROS_logo.webp";
// import BANBAJIO_SEGUROS_image from "../assets/Seguros/BANBAJIO_SEGUROS_logo.webp";
import BANORTE_image from "../assets/Seguros/BANORTE_logo.webp";
// import BANORTE_SEGUROS_2DA_image from "../assets/Seguros/BANORTE_SEGUROS_2DA_logo.webp";
import BANORTE_SEGUROS_image from "../assets/Seguros/BANORTE_SEGUROS_logo.png";
import BBVA_SEGUROS_image from "../assets/Seguros/BBVA_SEGUROS_logo.jpg";
import BBVA_SEGUROS_MULTIASISTENCIA_image from "../assets/Seguros/BBVA_SEGUROS_MULTIASISTENCIA_logo.png";
import BUPA_SEGUROS_image from "../assets/Seguros/BUPA_SEGUROS_logo.jpg";
import CHUBB_SEGUROS_ABA_image from "../assets/Seguros/CHUBB_SEGUROS_ABA_logo.png";
import CHUBB_SEGUROS_ACE_image from "../assets/Seguros/CHUBB_SEGUROS_ACE_logo.png";
// import FIRA_image from "../assets/Seguros/FIRA_logo.jpg";
import GENERAL_DE_SEGUROS_image from "../assets/Seguros/GENERAL_DE_SEGUROS_logo.jpg";
import GNP_SEGUROS_image from "../assets/Seguros/GNP_SEGUROS_logo.png";
import HDI_SEGUROS_image from "../assets/Seguros/HDI_SEGUROS_logo.png";
// import HEALTH_AND_PHARMA_CONTROL_image from "../assets/Seguros/HEALTH_AND_PHARMA_CONTROL_logo.png";
import HIR_SEGUROS_image from "../assets/Seguros/HIR_SEGUROS_logo.png";
import INBURSA_image from "../assets/Seguros/INBURSA_logo.jpg";
import LA_LATINO_SEGUROS_image from "../assets/Seguros/LA_LATINO_SEGUROS_logo.jpg";
import MAPFRE_MEXICO_image from "../assets/Seguros/MAPFRE_MEXICO_logo.png";
// import MEDIPROSES_image from "../assets/Seguros/MEDIPROSES_logo.jpg";
import METLIFE_image from "../assets/Seguros/METLIFE_logo.jpg";
// import NACIONAL_MONTE_DE_PIEDAD_image from "../assets/Seguros/NACIONAL_MONTE_DE_PIEDAD_logo.jpg";
import PLAN_SEGUROS_image from "../assets/Seguros/PLAN_SEGUROS_logo.jpg";
import PREVEM_image from "../assets/Seguros/PREVEM_logo.png";
import QUALITAS_image from "../assets/Seguros/QUALITAS_logo.png";
// import SCOTIABANK_INVERLAT_image from "../assets/Seguros/SCOTIABANK_INVERLAT_logo.jpg";
import SEGUROS_EL_POTOSI_image from "../assets/Seguros/SEGUROS_EL_POTOSI_logo.jpg";
import SEGUROS_MONTERREY_NEW_YORK_LIFE_image from "../assets/Seguros/SEGUROS_MONTERREY_NEW_YORK_LIFE_logo.png";
import SURA_SEGUROS_image from "../assets/Seguros/SURA_SEGUROS_logo.png";
import THONA_SEGUROS_image from "../assets/Seguros/THONA_SEGUROS_logo.jpg";
// import VITAMEDICA_image from "../assets/Seguros/VITAMEDICA_logo.png";
import ZURICH_MEXICO_image from "../assets/Seguros/ZURICH_MEXICO_logo.jpg";

// Informacion Seguros archivos PDF
import allianz_1 from "../assets/Seguros-formatos/ALLIANZ Aviso de accidente o enfermedad.pdf";
import allianz_2 from "../assets/Seguros-formatos/ALLIANZ Informe Médico.pdf";
import atlas_1 from "../assets/Seguros-formatos/ATLAS AVISO DE ACCI FF285 01-2022.pdf";
import atlas_2 from "../assets/Seguros-formatos/ATLAS INF MEDICO FF284 01-2022.pdf";
import axa_1 from "../assets/Seguros-formatos/AXA SEGUROS Solicitud de Siniestros.pdf";
import axa_2 from "../assets/Seguros-formatos/AXA SEGUROS Informe Medico.pdf";
import banorte_seguros_1 from "../assets/Seguros-formatos/BANORTE InformeReclamante.pdf";
import banorte_seguros_2 from "../assets/Seguros-formatos/BANORTE SIN.pdf";
import bbva_seguros_1 from "../assets/Seguros-formatos/BBVA aviso accidente.pdf";
import bbva_seguros_2 from "../assets/Seguros-formatos/BBVA informe-medico.pdf";
import gnp_1 from "../assets/Seguros-formatos/GNP aviso accidente.pdf";
import gnp_2 from "../assets/Seguros-formatos/GNP informe medico.pdf";
import inbursa_1 from "../assets/Seguros-formatos/INBURSA AVISO DE ACCIDENTE.pdf";
import inbursa_2 from "../assets/Seguros-formatos/INBURSA INFORME MEDICO.pdf";
import mapfre_1 from "../assets/Seguros-formatos/MAPFRE solicitud de pago.pdf";
import mapfre_2 from "../assets/Seguros-formatos/MAPFRE informe medico.pdf";
import metlife_1 from "../assets/Seguros-formatos/METLIFE solicitud de reclamacion.pdf";
import metlife_2 from "../assets/Seguros-formatos/METLIFE informe medico.pdf";
import planseguros_1 from "../assets/Seguros-formatos/PLAN SEGUROS aviso accidente.pdf";
import planseguros_2 from "../assets/Seguros-formatos/PLAN SEGUROS informe medico.pdf";
import prevem_1 from "../assets/Seguros-formatos/PREVEM aviso-accidente-enfermedad.pdf";
import prevem_2 from "../assets/Seguros-formatos/PREVEM informe-medico.pdf";
import segurosmonterrey_1 from "../assets/Seguros-formatos/SEGUROS MONTERREY aviso-de-accidente.pdf";
import segurosmonterrey_2 from "../assets/Seguros-formatos/SEGUROS MONTERREY informe-medico.pdf";
//import archivoDePrueba from "../assets/Especialistas/Informacion_Especialista/PATRONESCOLOR.pdf";

const telefonoExtensiones = "311 211 94 70 \nEXT. 174, 151, 134, 126";
const telefonoLlamadas = "3112119470";
const whatsAppNumber = "3112532295";

export const dataSeguros = [
  {
    id: "01",
    titulo: "METLIFE",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: METLIFE_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: metlife_1,
    pdf_2: metlife_2
  },
  {
    id: "02",
    titulo: "BANORTE",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: BANORTE_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "03",
    titulo: "SEGUROS MONTERREY NEW YORK LIFE",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: SEGUROS_MONTERREY_NEW_YORK_LIFE_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: segurosmonterrey_1,
    pdf_2: segurosmonterrey_2
  },
  {
    id: "04",
    titulo: "MAPFRE MEXICO",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_3: null,
    image: MAPFRE_MEXICO_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: "AUTOS SINIESTROS",
    subtipo_1: "ACCIDENTES PERSONALES",
    pdf_1: mapfre_1,
    pdf_2: mapfre_2
  },
  {
    id: "05",
    titulo: "AXA SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_3: null,
    image: AXA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: "AUTOS SINIESTROS",
    subtipo_1: "ACCIDENTES PERSONALES",
    pdf_1: axa_1,
    pdf_2: axa_2
  },
  {
    id: "06",
    titulo: "GNP SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: GNP_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: gnp_1,
    pdf_2: gnp_2
  },
  {
    id: "07",
    titulo: "ALLIANZ",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: ALLIANZ_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: allianz_1,
    pdf_2: allianz_2
  },
  {
    id: "08",
    titulo: "INBURSA",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_3: null,
    image: INBURSA_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: "AUTOS SINIESTROS",
    subtipo_1: null,
    pdf_1: inbursa_1,
    pdf_2: inbursa_2
  },
  {
    id: "09",
    titulo: "ATLAS SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_3: null,
    image: ATLAS_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: "AUTOS SINIESTROS",
    subtipo_1: null,
    pdf_1: atlas_1,
    pdf_2: atlas_2
  },
  {
    id: "10",
    titulo: "BUPA SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: BUPA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "11",
    titulo: "PLAN SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: PLAN_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: planseguros_1,
    pdf_2: planseguros_2
  },
  {
    id: "12",
    titulo: "PREVEM",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: PREVEM_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: prevem_1,
    pdf_2: prevem_2
  },
  {
    id: "13",
    titulo: "BBVA SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD.",
    subtitulo_2: null,
    subtitulo_3: null,
    image: BBVA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "GASTOS MEDICOS MAYORES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: bbva_seguros_1,
    pdf_2: bbva_seguros_2
  },
  {
    id: "14",
    titulo: "QUALITAS",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_3: null,
    image: QUALITAS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: "ACCIDENTES PERSONALES",
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "15",
    titulo: "BANORTE SEGUROS",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: BANORTE_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: banorte_seguros_1,
    pdf_2: banorte_seguros_2
  },
  {
    id: "16",
    titulo: "CHUBB SEGUROS (ABA)",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: CHUBB_SEGUROS_ABA_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "17",
    titulo: "A.N.A. SEGUROS",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: ANA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "18",
    titulo: "GENERAL DE SEGUROS",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_3: null,
    image: GENERAL_DE_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: "ACCIDENTES PERSONALES",
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "19",
    titulo: "BBVA SEGUROS (MULTIASISTENCIA)",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: BBVA_SEGUROS_MULTIASISTENCIA_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "20",
    titulo: "ZURICH MEXICO",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: ZURICH_MEXICO_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "21",
    titulo: "SEGUROS EL POTOSI",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_3: null,
    image: SEGUROS_EL_POTOSI_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: "ACCIDENTES PERSONALES",
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "22",
    titulo: "HDI SEGUROS",
    subtitulo: "CONTAMOS CON CONVENIO CON ESTAS ASEGURADORAS, SOLO NECESITAS PRESENTAR TU PASE EXPEDIDO POR TU AJUSTADOR",
    subtitulo_2: null,
    subtitulo_3: null,
    image: HDI_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "AUTOS SINIESTROS",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "23",
    titulo: "CHUBB SEGUROS (ACE)",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: CHUBB_SEGUROS_ACE_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "24",
    titulo: "SURA SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: SURA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "25",
    titulo: "LA LATINO SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: LA_LATINO_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "26",
    titulo: "AIG SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: AIG_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "27",
    titulo: "THONA SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: THONA_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  {
    id: "28",
    titulo: "HIR SEGUROS",
    subtitulo: "PUEDES INICIAR TUS TRAMITES CON SU ASEGURADORA, TENEMOS DISPONIBLE FORMATO INFORME MEDICO Y AVISO DE ACCIDENTE/ENFERMEDAD",
    subtitulo_2: null,
    subtitulo_3: null,
    image: HIR_SEGUROS_image,
    telefono: telefonoExtensiones,
    telefonoMarcar: telefonoLlamadas,
    whatsapp: whatsAppNumber,
    tipo: "ACCIDENTES PERSONALES",
    subtipo: null,
    subtipo_1: null,
    pdf_1: null,
    pdf_2: null
  },
  // {
  //   id: "29",
  //   titulo: "ASISMED",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: ASISMED_SEGUROS_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "30",
  //   titulo: "MEDIPROSES",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: MEDIPROSES_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "31",
  //   titulo: "VITAMEDICA",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: VITAMEDICA_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "32",
  //   titulo: "HEALTH AND PHARMA CONTROL",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: HEALTH_AND_PHARMA_CONTROL_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "33",
  //   titulo: "BANCO MERCANTIL DEL NORTE",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: BANORTE_SEGUROS_2DA_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "34",
  //   titulo: "FIRA",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: FIRA_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "35",
  //   titulo: "NACIONAL MONTE DE PIEDAD",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: NACIONAL_MONTE_DE_PIEDAD_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "36",
  //   titulo: "BANBAJIO",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: BANBAJIO_SEGUROS_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
  // {
  //   id: "37",
  //   titulo: "SCOTIABANK INVERLAT",
  //   subtitulo: "CONTAMOS CON CONVENIO PARA PRESTAR SERVICIO MEDICO A DIVERSAS INSTITUCIONES BANCARIAS Y FIDEICOMISOS",
  //   subtitulo_2: null,
  //   subtitulo_3: null,
  //   image: SCOTIABANK_INVERLAT_image,
  //   telefono: telefonoExtensiones,
  //   telefonoMarcar: telefonoLlamadas,
  //   whatsapp: whatsAppNumber,
  //   tipo: "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  //   subtipo: null,
  //   subtipo_1: null,
  //   pdf: null
  // },
];

// Servicios Categorias
export const categoriaSeguros = [
  // "ADMINISTRADORA DE SERVICIOS MEDICOS / CONVENIOS DIRECTOS",
  "ACCIDENTES PERSONALES",
  "AUTOS SINIESTROS",
  "GASTOS MEDICOS MAYORES"
];
